"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var notification = document.createElement("div");
    notification.style.top = "".concat(posTop, "px");
    notification.style.right = "".concat(posRight, "px");
    notification.classList.add("notification", type);
    var titleELement = document.createElement("h2");
    titleELement.className = "title";
    titleELement.textContent = title;
    var descriptionElement = document.createElement("p");
    descriptionElement.textContent = description;
    notification.append(titleELement, descriptionElement);
    document.body.append(notification);
    setTimeout(function() {
        notification.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.a2049af7.js.map
